<success-screen bgImage="coinsCrypto" class="bp-modal mod-lg">
  <bp-modal-header
    header
    class="font-semibold"
    [title]="offer?.getType() + '_in_pending' | translate: [getTradable().getName()]">
    <a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div content>
    <div class="success-content-inner">
      <img
        class="success-image"
        src="/assets/images/success.svg"
        [alt]="offer?.getType() + '_successful' | translate" />
      <div class="success-headline mb-15">{{ offer?.getType() + "_in_pending" | translate }}</div>
      @if (!isIndexTrade()) {
        <p class="text-center mb-15 font-size-17 translation-helper">
          <span>{{
            offer?.getType() + "_in_pending_text"
            | translate
            : [
            offer?.getAmountTradable()
            | tradable_precision_symbol
            : {
            id: offer?.getCurrencyId(),
            currencies: [getTradable()],
            addName: true,
            dustThreshold: 0.0001
            },
            offer?.getAmountFiat()
            | fiat_precision_symbol
            : { id: offer?.getFiatId(), currencies: [getFiat()], symbol: true }
            ]
          }}</span>
          @if (isCashPlusSubscribed$ | async) {
            {{ "cash_plus_success_additional" | translate }}
          }
        </p>
      }

      @if (+itbAmount > 0) {
        <!-- Info box -->
        <span class="center-block mb-20">
          <instant-trade-bonus [amount]="itbAmount" [step]="ITBStep.SUCCESS" [showLoading]="showItbLoading">
          </instant-trade-bonus>
        </span>
      }

      <!-- Tax withholding info -->
      @if (taxWithheld; as tax) {
        <tax-success-amount-label-ui [taxWithheld]="tax"></tax-success-amount-label-ui>
      }

      <!-- Vision banner -->
      @let visionId = visionId$ | async;
      @let isUkUser = isUkUser$ | async;
      @if (
        (visionFeeFlag$ | async) &&
        !isUkUser &&
        offer?.getVsnFeeTokenCollection()?.globalOptIn !== null &&
        (offer?.getVsnFeeTokenCollection()?.eligibleForVsn || offer?.getCurrencyId() === visionId.getId()) &&
        (!offer?.getVsnFeeTokenCollection()?.globalOptIn ||
        (offer?.getVsnFeeTokenCollection()?.globalOptIn &&
        !offer?.getVsnFeeTokenCollection()?.visionFeeDetail.hasEnoughFunds))
        ) {
        <div class="vision-banner-container">
          <mo-success-vision-component
            [bannerState]="getVisionBannerState()"
            [feeAmount]="offer.getVsnFeeTokenCollection().feeDiscount"
          (click)="handleBannerClick()"></mo-success-vision-component>
        </div>
      }

			<!-- C+ should be removed in UK, comment for next sync -->
      <div class="mb-50 text-center">
        <a (click)="goToWallet()">{{ "go-to-wallet" | translate }}</a>
      </div>

      <!-- go to wallet -->

      @if (!isIndexTrade()) {
        <div class="mb-30 text-center">
          <button
            (click)="addPriceAlert()"
            class="btn btn-primary btn-success-modal mod-middle button-weight"
            type="button">
            {{ "add_pricealert" | translate: [getTradable().getSymbol(false, true)] }}
          </button>
        </div>
      }
    </div>
    <div class="text-center">
      @if (walletExists) {
        <button
          (click)="goToWallet()"
          class="btn btn-primary btn-success-modal"
          type="button">
          <strong>{{ "trade_pending_order_status" | translate }}</strong>
        </button>
      } @else {
        <button (click)="goToPortfolio()" class="btn btn-primary btn-success-modal" type="button">
          <strong>{{ "go_to_portfolio" | translate }}</strong>
        </button>
      }
    </div>
  </div>
</success-screen>
